/** @format */

import React from 'react'
import { Select, Option, Checkbox, Icon, TableColumn, Table, Button } from '@king-design/react'
import request from 'src/utils/request'
import API from 'src/api/ApiContacts'
import { useAsync } from 'react-use'
import { cloneDeep } from 'lodash'
export interface ConcatProps {
  ContactID: string | number
  ContactName?: string
  ContactFlag: number
  ContactWay: number
}

export interface UserItemProps {
  userid: number
  name: string
}
export interface GroupItemProps {
  usrgrpid: number
  name: string
}

interface AlarmReciverProps {
  value?: ConcatProps[]
  onChange?: (data: ConcatProps[]) => void
  maxLength?: number
  style?: React.CSSProperties
  readonly?: boolean
  userlist?: UserItemProps[]
  grouplist?: GroupItemProps[]
}

const AlarmReciver: React.FC<AlarmReciverProps> = ({
  value = [],
  onChange,
  maxLength = 10,
  style,
  readonly = false,
  userlist: userListProp,
  grouplist: grouplistProp
}) => {
  const { value: result } = useAsync(async () => {
    const userlist =
      userListProp ||
      (
        await request(API.getAlertUser, {
          method: 'get',
          data: {
            PageIndex: 1,
            Cap: 1
          }
        })
      ).data?.userlist ||
      []

    const grouplist =
      grouplistProp ||
      (
        await request(API.getUserGroup, {
          method: 'get',
          data: {
            PageIndex: 1,
            Cap: 1
          }
        })
      ).data?.usergrplist ||
      []
    return {
      userlist,
      grouplist
    }
  }, [userListProp, grouplistProp])

  const onTableChange = (data, index) => {
    const clone = cloneDeep(value)
    clone[index] = { ...clone[index], ...data }
    onChange && onChange(clone)
  }

  return (
    <div className="alarm_reciver" style={style || {}}>
      <Table data={value || []} animation={false} rowKey={data => data.ContactID} checkType="none">
        <TableColumn
          key="ContactName"
          title="接收人"
          slotTemplate={([data, index]) => {
            return readonly ? (
              <span>
                {data.ContactName}({data.ContactFlag === 1 ? '联系组' : '联系人'})
              </span>
            ) : (
              <Select
                filterable
                container={() => document.getElementsByClassName('alarm_reciver')[0]}
                value={data.ContactID}
                onChangeValue={value => {
                  onTableChange({ ContactID: value }, index)
                }}
              >
                {/* 1=联系组 2=联系人 */}
                {data.ContactFlag === 1
                  ? result?.grouplist?.map(opt => {
                      const disabled = value.find(
                        item => item.ContactFlag === 1 && item.ContactID === opt.usrgrpid
                      )
                      return (
                        <Option disabled={!!disabled} key={opt.usrgrpid} value={opt.usrgrpid}>
                          {opt.name}
                        </Option>
                      )
                    })
                  : null}
                {data.ContactFlag === 2
                  ? result?.userlist?.map(opt => {
                      const disabled = value.find(
                        item => item.ContactFlag === 2 && item.ContactID === opt.userid
                      )
                      return (
                        <Option disabled={!!disabled} key={opt.userid} value={opt.userid}>
                          {opt.name}
                        </Option>
                      )
                    })
                  : null}
              </Select>
            )
          }}
        />
        <TableColumn
          width="30%"
          key="ContactWay"
          title="通知方式"
          slotTemplate={([data, index]) => {
            return readonly ? (
              <span>
                {data.ContactWay === 1
                  ? '邮箱'
                  : data.ContactWay === 2
                  ? '短信'
                  : data.ContactWay === 3
                  ? '邮箱+短信'
                  : '-'}
              </span>
            ) : (
              <>
                <Checkbox
                  style={{ marginRight: '8px' }}
                  value={data.ContactWay === 1 || data.ContactWay === 3 ? true : false}
                  onChangeValue={val => {
                    const newData = cloneDeep(value)
                    const currentWay = newData[index].ContactWay
                    if ((currentWay === 1 || currentWay === 2) && val === true) {
                      newData[index].ContactWay = 3
                    } else if (currentWay === 0) {
                      newData[index].ContactWay = 1
                    } else if (currentWay === 3) {
                      newData[index].ContactWay = 2
                    } else {
                      newData[index].ContactWay = 0
                    }
                    onChange(newData)
                  }}
                >
                  邮箱
                </Checkbox>
                <Checkbox
                  value={data.ContactWay === 2 || data.ContactWay === 3 ? true : false}
                  onChangeValue={val => {
                    const newData = cloneDeep(value)
                    const currentWay = newData[index].ContactWay
                    if ((currentWay === 1 || currentWay === 2) && val === true) {
                      newData[index].ContactWay = 3
                    } else if (currentWay === 0) {
                      newData[index].ContactWay = 2
                    } else if (currentWay === 3) {
                      newData[index].ContactWay = 1
                    } else {
                      newData[index].ContactWay = 0
                    }
                    onChange(newData)
                  }}
                >
                  短信
                </Checkbox>
              </>
            )
          }}
        />
        <TableColumn
          key="operate"
          title="操作"
          hidden={readonly}
          width="80"
          slotTemplate={([data, index]) => {
            return (
              <a
                onClick={() => {
                  const clone = cloneDeep(value)
                  clone.splice(index, 1)
                  onChange && onChange(clone)
                }}
              >
                删除
              </a>
            )
          }}
        ></TableColumn>
      </Table>

      {readonly ? null : (
        <p style={{ margin: 0, lineHeight: '32px' }}>
          <Button
            disabled={value.length >= maxLength}
            type="link"
            onClick={() => {
              onChange([
                ...value,
                {
                  ContactID: '',
                  ContactName: '',
                  ContactFlag: 1,
                  ContactWay: 3
                }
              ])
            }}
          >
            <Icon color="#0091ea" className="ion-plus-round" />
            添加联系组
          </Button>

          <Button
            disabled={value.length >= maxLength}
            type="link"
            onClick={() => {
              onChange([
                ...value,
                {
                  ContactID: '',
                  ContactName: '',
                  ContactFlag: 2,
                  ContactWay: 3
                }
              ])
            }}
          >
            <Icon color="#0091ea" className="ion-plus-round" />
            添加联系人
          </Button>
        </p>
      )}
    </div>
  )
}

export default AlarmReciver
